export default {
  data: () => ({
    feelings: [
      {
        index: 0,
        icon: "mdi-emoticon-neutral-outline",
        message: "Set your feeling",
        color: "",
      },
      {
        index: 1,
        icon: "mdi-emoticon-cool-outline",
        message: "Great!",
        color: "green darken-2",
      },
      {
        index: 2,
        icon: "mdi-emoticon-happy-outline",
        message: "Happy",
        color: "green darken-2",
      },
      {
        index: 3,
        icon: "mdi-emoticon-neutral-outline",
        message: "Fine",
        color: "green darken-2",
      },
      {
        index: 4,
        icon: "mdi-emoticon-sad-outline",
        message: "Sad",
        color: "green darken-2",
      },
      {
        index: 5,
        icon: "mdi-emoticon-cry-outline",
        message: "Stressed!",
        color: "green darken-2",
      },
    ],
  }),
  methods: {
    getEmoticonForRating(rating) {
      switch (rating) {
        case 1:
          return "mdi-emoticon-dead-outline";
        case 2:
          return "mdi-emoticon-sad-outline";
        case 3:
          return "mdi-emoticon-neutral-outline";
        case 4:
          return "mdi-emoticon-happy-outline";
        case 5:
          return "mdi-emoticon-excited-outline";
        default:
          return "";
      }
    },
    getColorForRating(rating) {
      switch (rating) {
        case 1:
          return "red";
        case 2:
          return "orange";
        case 3:
          return "yellow";
        case 4:
          return "green";
        case 5:
          return "green darken-2";
        default:
          return "";
      }
    },
  },
};
